import { useTranslation } from 'next-i18next'

import appConfig from '~/config/app'
import { Link } from '~/components/Link'
import ROUTES from '~/shared/constants/routes.const'

interface Props {
  className?: string
  onClickHandler?: () => void
  variant?: 'default' | 'menu'
}
export default function BookTutorButton({
  className = '',
  onClickHandler = () => {},
  variant = 'default',
}: Props): React.ReactElement | null {
  const { t } = useTranslation('footer')

  // Booking 404s in the school platform. Gated here rather than at the two call sites (Footer and
  // MenuBottomBar) so any future placement is covered too.
  if (appConfig.isSchoolPlatform) return null

  return (
    <Link
      className={`${className} ${
        variant === 'menu' ? 'rounded-full text-purple-darker shadow-low-opacity-black' : 'rounded text-black'
      } bg-orange text-center py-3 px-5.5 font-semibold text-sm`}
      onClick={onClickHandler}
      to={ROUTES.BOOKING_FOR_SELF}
    >
      {t('bookTutor')}
    </Link>
  )
}
